import React from 'react';
import styleSmallText from './SmallText.module.scss';
// import './SmallText.scss';
import { Form, Checkbox, Switch } from 'antd';

const SmallText = (props) => {

    return (
        <>
            {props.description === 1 ? (
                <>
                    <Form.Item
                        name="informativaPrivacy"
                        valuePropName="checked"
                        className={styleSmallText.CheckboxPrivacy}
                        rules={[
                            {
                                validator: (_, value) =>
                                    value
                                        ? Promise.resolve()
                                        : Promise.reject(
                                              "Devi accettare i termini dell'informativa sulla privacy."
                                          ),
                            },
                        ]}
                    >
                        <Checkbox onChange={props.changePrivacyCheckbox}>
                            {/* Ho preso visione <span className={styleSmallText.SmallTextSpan}><a href={props.linkInformativa} download rel="noopener noreferrer" target="_blank">dell’INFORMATIVA SULLA PRIVACY e dell’INFORMATIVA SIC</a></span> */}
                            Ho preso visione della
                            <a
                                className={styleSmallText.SmallTextSpan}
                                href={props.linkInformativa}
                                download
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                {" "}
                                INFORMATIVA PRIVACY e SIC
                            </a>
                            , e della{" "}
                            <a
                                href="#0"
                                className={styleSmallText.SmallTextSpan}
                                onClick={props.clicked}
                            >
                                INFORMATIVA PRECONTRATTUALE
                            </a>
                        </Checkbox>
                    </Form.Item>
                    <p className={styleSmallText.SmallText}>
                        Il Cliente dichiara di aver fornito, ai sensi del D.Lgs.
                        231/07, sotto la propria responsabilità, tutte le
                        informazioni necessarie e aggiornate per consentire a
                        Prestipay S.p.A. di adempiere agli obblighi di adeguata
                        verifica della clientela e di essere il titolare
                        effettivo. Il Cliente dichiara inoltre di agire per
                        scopi estranei all'attività imprenditoriale,
                        commerciale, artigianale o professionale eventualmente
                        svolta.
                        <br />
                        Fermo restando il trattamento dei miei dati personali
                        per le finalità di esecuzione dei contratti, adempimenti
                        normativi e per le finalità di legittimo interesse,
                        presto a Prestipay S.p.A., in qualità di Titolare del
                        trattamento, il consenso all'utilizzo dei miei dati
                        personali per le seguenti finalità:
                    </p>
                </>
            ) : props.description === 2 ? (
                <p className={styleSmallText.SmallText}>
                    Procedendo con la richiesta dichiaro di aver scaricato letto
                    e compreso la documentazione di trasparenza. Dichiaro
                    inoltre di voler inoltrare la richiesta preventiva di
                    finanziamento, autorizzando Prestipay ad utilizzare i dati
                    forniti per valutare la fattibilità del finanziamento
                    richiesto, anche tramite consultazione di banche dati
                    esterne, e per le finalità da me sopra indicate. Infine,
                    acconsento all’utilizzo di tecniche di comunicazione a distanza (T.C.D.)
                    e, pertanto, tutte le comunicazioni relative al contratto possono essere
                    effettuate anche mediante T.C.D., salvo non sia diversamente previsto dalla legge.
                </p>
            ) : props.description === 3 ? (
                <div className={styleSmallText.SwitchPrivacyWrapper}>
                    <Form.Item
                        name="informativaPrivacy"
                        valuePropName="checked"
                        className={styleSmallText.CheckboxPrivacy}
                        rules={[
                            {
                                validator: (_, value) =>
                                    value
                                        ? Promise.resolve()
                                        : Promise.reject(
                                              "Devi accettare i termini dell'informativa sulla privacy."
                                          ),
                            },
                        ]}
                    >
                        <Switch
                            onChange={props.changePrivacyCheckbox}
                            checkedChildren="SI"
                            unCheckedChildren="NO"
                        />
                    </Form.Item>
                    <span className={styleSmallText.SwitchPrivacyText}>
                        Ho preso visione della
                        <a
                            className={styleSmallText.SmallTextSpan}
                            href={props.linkInformativa}
                            download
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            {" "}
                            INFORMATIVA PRIVACY e SIC
                        </a>
                        , e della{" "}
                        <a
                            href="#0"
                            className={styleSmallText.SmallTextSpan}
                            onClick={props.clicked}
                        >
                            INFORMATIVA PRECONTRATTUALE
                        </a>
                        . Acconsento all’utilizzo di T.C.D.
                    </span>
                </div>
            ) : props.description === 4 ? (
                <p className={styleSmallText.SmallText}>
                    Il Cliente dichiara di aver fornito, ai sensi del D.Lgs.
                    231/07, sotto la propria responsabilità, tutte le
                    informazioni necessarie e aggiornate per consentire a
                    Prestipay S.p.A. di adempiere agli obblighi di adeguata
                    verifica della clientela e di essere il titolare effettivo.
                    Il Cliente dichiara inoltre di agire per scopi estranei
                    all'attività imprenditoriale, commerciale, artigianale o
                    professionale eventualmente svolta.
                    <br />
                    Fermo restando il trattamento dei miei dati personali per le
                    finalità di esecuzione dei contratti, adempimenti normativi
                    e per le finalità di legittimo interesse, presto a Prestipay
                    S.p.A., in qualità di Titolare del trattamento, il consenso
                    all'utilizzo dei miei dati personali per le seguenti
                    finalità:
                </p>
            ) : null}
        </>
    );

}

export default SmallText;